import { isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));

// Dev-only LocatorJS-style component inspector (Alt+hover / Alt+Click). Tree-shaken from prod builds.
if (isDevMode()) {
  import('./app/dev/component-locator').then((m) => m.enableComponentLocator());
}
